import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { GrView } from "react-icons/gr";
import { useStateContext } from "../contexts/ContextProvider";
import axios from "axios";
import { useNavigate } from "react-router-dom";
const CarouselContainer = ({ categ, id }) => {
  const { singleCategory, singleCategoryDetails } = useStateContext();
  const navigate = useNavigate();
  const [moreLike, setMoreLike] = useState();
  useEffect(() => {
    singleCategory(categ);
    console.log(categ);
  }, [categ]);

  useEffect(() => {
    if (singleCategoryDetails) {
      const filteredItems = singleCategoryDetails
        .filter(
          (item) => item.availability_date === null && item.desc_id === null
        )
        .slice(10, 20);
      setMoreLike(filteredItems);
    }
  }, [singleCategory]);

  //  const singleItem = (id) => {
  //     axios
  //       .get(`https://matrix-api-h2bb.onrender.com/item/${id}`)
  //       .then((res) => setItemDetail(res.data[0]));
  //   };

  const responsive = {
    superLargeDesktop: {
     
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <Component>
      {console.log(moreLike)}
      <h4>More Items Like This</h4>
      <ComponetWrapper>
        {moreLike && (
          <Carousel className="caro" responsive={responsive}>
            {moreLike?.map((item, i) => (
              <div
                className="card"
                key={i}
                onClick={() =>
                  navigate(`/itemdetails/${item.prod_id}/${item.categories_id}`)
                }
              >
                <img className="image" src={item?.image} alt="" />
                <div className="display-wrapper">
                  <p>{item?.descr}</p>
                  <div className="ctaWrapper">
                    <p>${item.price}</p>
                    <GrView className="font" />
                  </div>
                </div>
              </div>
            ))}

          </Carousel>
        )}
      </ComponetWrapper>
    </Component>
  );
};

export default CarouselContainer;

const Component = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
`;

const ComponetWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .react-multi-carousel-list {
    width: 80%;
    height: auto;
    margin-bottom: 70px;
  }
  .card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 300px;
    height: 330px;
    border: 1px solid #fbebf6;
    position: relative;
    .image {
      width: 300px;
      height: 190px;
      object-fit: contain;
      position: absolute;
      top: 20px;
    }
    .display-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-top: 14px;
      background: #fce5f1;
      position: absolute;
      bottom: 0;
      right: 0;
      p {
        width: 90%;
        font-size: 12px;
      }
      .ctaWrapper {
        width: 80%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .font {
         color: #95ae95!important;
          &:hover {
            color: red;
            
          }
        }
      }
    }
  }
`;
